import { render } from "./BoundingBoxDisplay.vue?vue&type=template&id=1cd6ec60&scoped=true"
import script from "./BoundingBoxDisplay.vue?vue&type=script&lang=js"
export * from "./BoundingBoxDisplay.vue?vue&type=script&lang=js"

import "./BoundingBoxDisplay.vue?vue&type=style&index=0&id=1cd6ec60&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd6ec60"]])

export default __exports__